'use client';

import { createContext } from 'react';

import type { AnalyticsState } from './types';

export const AnalyticsContext = createContext<AnalyticsState | null>(null);
